import { createAction, props } from '@ngrx/store';
import { Parcel } from 'src/app/models/parcel';

export enum ParcelActionTypes {
    setActiveParcel = '[parcel] set active parcel',
}

export const SetActiveParcel = createAction(
    ParcelActionTypes.setActiveParcel,
    props<{ parcel: Parcel | undefined }>()
);
